import { container } from "./material-kit-react.js"

const signupPageStyle = {
  container: {
    ...container,
    zIndex: "2",
    position: "relative",
    paddingTop: "10vh",
    color: "#D4AF37",
    paddingBottom: "200px",
    "@media (max-width: 960px)": {
      paddingTop: "90px",
      paddingBottom: "60px",
      paddingLeft: "12px",
      paddingRight: "12px",
      maxWidth: "100% !important",
      width: "100%"
    },
    "@media (max-width: 600px)": {
      paddingTop: "80px",
      paddingBottom: "40px"
    }
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  pageHeader: {
    minHeight: "100vh",
    height: "auto",
    display: "inherit",
    position: "relative",
    margin: "-8px",
    padding: "0",
    border: "0",
    alignItems: "center",
    backgroundColor: '#000',
    "&:before": {
      background: "rgba(0, 0, 0, 0.5)"
    },
    "&:before,&:after": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: '""'
    },
    "& footer li a,& footer li a:hover,& footer li a:active": {
      color: "#FFFFFF"
    },
    "& footer": {
      position: "absolute",
      bottom: "0",
      width: "100%"
    },
    "@media (max-width: 600px)": {
      minHeight: "auto",
      paddingBottom: "120px",
      "& footer": {
        position: "relative",
        bottom: "auto"
      }
    }
  },
  form: {
    margin: "0"
  },
  cardHeader: {
    width: "auto",
    textAlign: "center",
    marginLeft: "20px",
    marginRight: "20px",
    marginTop: "-40px",
    padding: "20px 0",
    marginBottom: "15px",
    "& h4": {
      color: '#D4AF37'
    },
    "@media (max-width: 600px)": {
      marginLeft: "12px",
      marginRight: "12px",
      marginTop: "-30px",
      padding: "16px 8px"
    }
  },
  socialIcons: {
    maxWidth: "24px",
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px"
  },
  divider: {
    marginTop: "30px",
    marginBottom: "0px",
    textAlign: "center"
  },
  cardFooter: {
    paddingTop: "0rem",
    border: "0",
    borderRadius: "6px",
    justifyContent: "center !important"
  },
  socialLine: {
    marginTop: "1rem",
    textAlign: "center",
    padding: "0"
  },
  inputIconsColor: {
  color: "#D4AF37"
  },
  forgotButton:{
    margin:0,
    marginTop: "-20px",
    textTransform: "none",
    padding: '0 0',
    color: '#828282',
    fontSize:10
  },
  normalButton:{
  margin:0,
  marginTop:'-15px',
  color: '#D4AF37',
  "@media (max-width: 600px)": {
    fontSize: '13px',
    padding: '10px 12px',
    width: '100%'
  }
  },
  inputRtl: {
    "& label": {
      transformOrigin: "top left",
      right: 28,
      left: "auto"
    },
    "& legend": {
      textAlign: "right"
    }
  }
};

export default signupPageStyle;
